<template>
  <div class="page">
    <!--弹出框 选择是否-->
    <pop :display='popDisplay' @closeHandler='closePop' @okHandler='CancelBreakfast' title='提示' :msg='popMsg' :onlyOk='popOnlyOk' />

    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
    <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh" />
      <!--返回上一层-->
      <pageTitle title='早餐券' />

    </mu-appbar>
    <!--主页面-->
    <div style="background-color:#F5F5F5 ; min-height:12.4rem">

      <mu-tabs :value="activeTab" @change="handleTabChange">
        <mu-tab value="0" title="进行中的订单" />
        <mu-tab value="1" title="历史订单" />
        <!--<mu-tab value="2" title="已过期" />-->
      </mu-tabs>
      <div style='height: 0.2rem;'></div>

      <div v-for='(ListName,index) in ["0","1","2"]'>
        <!--v-on:click='LookCode( item.hotelcode,item.ticketNo )'-->
        <div v-if="ListName == activeTab " v-for='(item,index) in BreakfastList[activeTab]'>
          <div style="background-color:#fff; width:6.9rem; margin:0  0.3rem;  ">

            <div style=" font-size:0.24rem; color:#999 ;  padding: 0 0.35rem ; line-height:0.8rem  ; border-bottom: 1px solid #F4F4F5; ">
              订单号：{{ item.breakfastResvNo }}
            </div>
            <div style=" font-size:0.3rem; color:#000 ; font-weight:bold ;  padding: 0.25rem 0.35rem   ;  ">
              {{ item.HotelName }}
            </div>
            <div style=" font-size:0.24rem; color:#999 ; line-height:0.36rem ;  padding: 0 0.35rem   ;  ">
              <div style="  "> 购买时间： {{ item.createtimeText }} </div>
              <div style="  "> 有效日期： {{ item.StartTimeText }} 至 {{ item.EndTimeText }} </div>
              <div style="  ">
                金
                <span style="color:white">金额</span>额：￥{{ item.AAListBag[0].paymoney}} × {{ item.countPerDay }}张 × {{ item.CostDays }}天
              </div>
            </div>
            <div style='height: 0.2rem; margin: 0  0.35rem ;border-bottom: 1px solid #F4F4F5;'></div>

            <!--下面的按钮-->
            <div v-if="ListName ==0 " style="  overflow:hidden ; height:1.05rem ;  padding: 0.25rem 0.35rem ">
              <div style=" float:left ; font-size:0.26rem; color:#666 ;   padding: 0.1rem 0    ;  ">
                合计：
                <span style=" font-weight:bold ;color:#27ba69 ;font-size:0.24rem; height:0.1rem">
                  ￥
                  <span style=" font-size:0.3rem; ">{{ item.countPerDay* item.CostDays *item.AAListBag[0].paymoney | KeepTwoNum }} </span>
                </span>
              </div>

              <div v-on:click="GoPay(item)" v-if=" item.AAListBag[0].ticketNo =='' " style="color:#ffa135 ; border:1px solid #ffa135 ;" class='opBtn payBtn'>
                去支付
              </div>
              <div v-else v-on:click=" LookDetails( item ) " class='opBtn payBtn'>
                查看订单
              </div>
              <div class='opBtn' v-on:click=" openPop( item.breakfastResvNo,  item.AAListBag[0].ticketNo )">
                取消订单
              </div>
            </div>

            <div v-if="ListName ==1 " style="  overflow:hidden ; height:1rem ;  padding: 0.25rem 0.35rem ">
              <div style=" float:left ; font-size:0.26rem; color:#666 ;   padding: 0.1rem 0    ;  ">
                合计：
                <span style=" font-weight:bold ;color:#27ba69 ;font-size:0.24rem; height:0.1rem">
                  ￥
                  <span style=" font-size:0.3rem; ">{{ item.countPerDay* item.CostDays *item.AAListBag[0].paymoney | KeepTwoNum }} </span>
                </span>
              </div>

              <div class='opBtn payBtn' v-on:click=" LookDetails( item ) " v-if=" item.AAListBag[0].ticketNo != '' ">
                查看订单
              </div>
            </div>

          </div>
          <!--     <div style="      ">  </div>        -->
          <div style='height: 0.2rem;'></div>
        </div>
      </div>

      <loadListTail mainTitle='您目前没有早餐券哦！' mainIcon='noVoucher' :noMore='loadState[this.activeTab].stop' :isLoading='loadState[this.activeTab].loading' :overZero='BreakfastList[activeTab].length > 0' />

      <div style="text-align:center;padding:0.2rem;" v-if='loadState[this.activeTab].loading'>
        <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
      </div>
      <div style='height: 0.1rem;'></div>

    </div>

    <!--<div v-if='vo.Status == "0" && g_currentOrder.freeVoucherInfo.useNotSee' v-bind:class="{ 'active': vo.selected }" class='fBtn'></div>-->

  </div>
</template>





<script>
import pageTitle from '../../components/pageTitle.vue'
import pop from '../../components/pop'

import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data() {
    return {

      // 弹出标签 选择是否
      popDisplay: false,
      popMsg: '',
      popOnlyOk: false,
      // 弹出标签 选择是否


      NowUser: "",

      activeTab: '0',

      Code2dStr: '',
      Code2dImg: '',

      dialog: false,
      toast: false,

      BreakfastList: [[], [], []],


      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      hintMsg: '',
      pageSize: 10,
      refreshing: false,
      trigger: null,
      couponCode: '',
      scroll: null
    }
  },
  activated() {



    if (this.NowUser != this.g_UserInfo.Card_no) {

      this.NowUser = this.g_UserInfo.Card_no;

      this.BreakfastList = [[], [], []]
      this.scroll.initLoadState()
    }
    else
      this.scroll.addHandler()


  },
  mounted() {
    this.trigger = this.$el
    this.scroll = Scroll.Create(this, this.getData, this.pageSize, 3)
  },
  deactivated() {
    this.closePop()

    // this.getSelected()
    this.scroll.removeHandler()
  },
  components: {
    loadListTail, pageTitle, pop
  },
  methods: {
    ...mapMutations(['setG_currentOrder', 'setG_breakfastInfo', 'setG_PayOrder'
    ]),



    initData() {

      //清空显示数据
      this.BreakfastList.splice(this.activeTab, 1, [])


      //初始化本页控制数据、分页参数
      this.scroll.refresh()
    },
    refresh() {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },
    // 获取早餐数据
    getData() {
      var Tab = this.activeTab
      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex', this.pageParam[Tab].index);
      params.append('pageSize', this.pageSize);
      params.append('useType', Tab);
      //useType  =  未使用0，已使用1，已过期2，已作废 3

      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetBreakfastTicketList(), params.toParam()).then((res) => {
          if (res.Result) {

            var temp = res.Data

            if (temp == null) {
              resolve(null)
            }
            else {
              // that.initFreeVOuchers(temp)
              resolve(temp.length)
              that.BreakfastList[Tab] = that.BreakfastList[Tab].concat(temp)

            }
          }
          else {
            resolve(null)
            that.showToast(res.Message)
          }
        })
      })

    },
    //三个分页
    handleTabChange(val) {
      this.activeTab = val;
      this.scroll.changeType(val)
    },


    // LookCode(a, b) {
    //   this.Code2dStr = b;
    //   this.Code2dImg = api.Code2D(a + '|' + b);
    // },

    // 缓存数据，跳转
    LookDetails(item) {

      console.log(item)

      this.setG_breakfastInfo(item);
      this.$router.push({ path: '/user/BreakfastDetails' });
    },
    // CleanShadow() {
    //   this.Code2dStr = '';
    // },



    // 弹出层
    showToast(msg) {
      this.hintMsg = msg;
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.hintMsg == '请先登录') {
        this.NowUser = "";
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    closePop() {
      this.popDisplay = false
    },

    openPop(val1, val2) {
      //     this.popOnlyOk = onlyOk

      this.tmpval1 = val1
      this.tmpval2 = val2
      this.popDisplay = true

      this.popMsg = "确认取消订单吗？";
    },


    // 功能性的东西  END


    // 取消订单
    CancelBreakfast(val, type) {

      var val = this.tmpval1
      var type = this.tmpval2

      this.closePop()

      var msg = "";
      if (type != "")
        msg = "IsPay";

      var params = new this.URLSearchParam();
      params.append('breakfastResvNo', val)
      this.$http.post(api.CancelBreakfast(msg), params.toParam()).then((res) => {
        if (res.Result) {

          this.showToast(res.Data)
          this.refresh();
        }
        else {
          this.showToast(res.Message)
        }
      })
    },

    // 进入付钱页面
    GoPay(item) {


      var Order = this.g_PayOrder;

      Order.Money = item.countPerDay * item.CostDays * item.AAListBag[0].paymoney;
      Order.OrderId = item.breakfastResvNo;
      this.setG_PayOrder(Order);

      this.$router.push({ path: '/payOrder/breakfastPayType' });

    },



  },
  computed: {
    ...mapGetters(['g_UserInfo', 'g_currentOrder', 'g_searchParam ', 'g_PayOrder']),
  },
  filters: {
    KeepTwoNum(val) {

      val = Number(val);
      return val.toFixed(2);
    }

  },

}
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.opBtn {
  border: 1px solid #cccccc;
  font-size: 0.24rem;
  color: #999999;
  text-align: center;
  width: 1.67rem;
  height: 0.57rem;
  line-height: 0.57rem;
  float: right;
}

.payBtn {
  border: 1px solid #27ba69;
  color: #27ba69;
  margin-left: 0.12rem;
}
</style>







// WEBPACK FOOTER //
// Breakfast.vue?48c02b67